/* Number / money formatting helpers (mirrors the prototype's fmt$/fmtM feel). */
export const money = (n: number | null | undefined): string => {
  if (n == null || !isFinite(n)) return '—';
  // Sign before the symbol (-$1.50M), as the engine's fmtM prints it. Formatting
  // the signed value inside the template gave "$-1.50M" for a loss or negative cash.
  const abs = Math.abs(n);
  const sign = n <= -0.5 ? '-' : '';
  if (abs >= 1e9) return `${sign}$${(abs / 1e9).toFixed(2)}B`;
  if (abs >= 1e6) return `${sign}$${(abs / 1e6).toFixed(2)}M`;
  if (abs >= 1e3) return `${sign}$${(abs / 1e3).toFixed(1)}k`;
  return `${sign}$${Math.round(abs)}`;
};

export const pct = (n: number | null | undefined, digits = 1): string =>
  n == null || !isFinite(n) ? '—' : `${(n * 100).toFixed(digits)}%`;

export const num = (n: number | null | undefined): string =>
  n == null || !isFinite(n) ? '—' : n.toLocaleString('en-US', { maximumFractionDigits: 0 });

export const price = (n: number | null | undefined): string =>
  n == null || !isFinite(n) ? '—' : `$${Math.round(n)}`;
